export default function getUrlVars() {
	var vars = {}
	typeof window !== 'undefined' && window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
		vars[key] = value
	})
	return vars
}
